import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bbf2f49a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bbf2f49a&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=bbf2f49a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2f49a",
  null
  
)

export default component.exports